import { queryOptions } from "@tanstack/react-query"
import { createFileRoute } from "@tanstack/react-router"
import { CountryCodeMappingsPage } from "@/features/country-code-mappings/components/CountryCodeMappingsPage"
import { listCountryCodeMappingsFn } from "@/features/country-code-mappings/server/countryCodeMappings"
import { countryCodeMappingQueryKeys } from "@/lib/queryKeys"

export const countryCodeMappingsQuery = () =>
  queryOptions({
    queryKey: countryCodeMappingQueryKeys.list(),
    queryFn: () => listCountryCodeMappingsFn(),
    // listCountryCodeMappingsFn returns { mappings, countries }
  })

export const Route = createFileRoute("/(authenticated)/settings/country-code-mappings/")({
  loader: ({ context }) => {
    void context.queryClient.ensureQueryData(countryCodeMappingsQuery())
  },
  component: CountryCodeMappingsPage,
})
